import { Theme } from '@theme'
import { Dimensions, StyleSheet } from 'react-native'

const screenWidth = Dimensions.get('window').width

export default (theme: Theme, top?: number) =>
  StyleSheet.create({
    //Step1
    scrollviewContainer: {
      width: screenWidth,
    },
    scrollviewContentContainer: {
      paddingBottom: theme.spacing.xl,
      paddingHorizontal: theme.spacing.xl,
      alignItems: 'center',
    },
    errorMessage: {
      paddingVertical: theme.spacing.sm,
      paddingLeft: theme.spacing.lg,
    },
    textInputContainer: {
      paddingTop: theme.spacing.xl,
    },

    //Step2 & Step3
    container: {
      flex: 1,
      width: screenWidth,
      alignItems: 'center',
      paddingBottom: theme.spacing.xl,
      paddingHorizontal: theme.spacing.xl,
    },
    button: {
      paddingTop: theme.spacing.xl,
      justifyContent: 'flex-end',
    },

    //Step4
    containerPreference: {
      flex: 1,
      width: screenWidth,
      paddingBottom: theme.spacing.xl,
    },
    list: {
      flex: 1,
      paddingLeft: theme.spacing.xxl,
    },
    buttonPreferences: {
      paddingTop: theme.spacing.lg,
      paddingBottom: theme.spacing.xl,
      paddingHorizontal: theme.spacing.xl,
    },

    //finalStep
    finalContainer: {
      flex: 1,
      paddingTop: top && top + theme.spacing.xxxl,
      paddingBottom: theme.spacing.xl,
      paddingHorizontal: theme.spacing.xl,
      alignItems: 'center',
    },
    finalTitleContainer: {
      flex: 1,
      justifyContent: 'flex-start',
      paddingTop: theme.spacing.xxxl * 2,
      paddingHorizontal: theme.spacing.xl,
    },
    finalTitle: {
      textAlign: 'center',
    },
    // Web uniquement : ombre légère pour garder le titre blanc lisible sur le ciel clair.
    finalTitleWeb: {
      textShadowColor: 'rgba(0,0,0,0.4)',
      textShadowOffset: { width: 0, height: 1 },
      textShadowRadius: 8,
    },
    finalButton: {
      paddingBottom: theme.spacing.xl,
    },
    backButton: {
      position: 'absolute',
      top: top ? top + theme.spacing.lg : theme.spacing.xl,
      left: theme.spacing.xl,
      zIndex: 1,
      padding: theme.spacing.sm,
    },
    geolocationCard: {
      backgroundColor: theme.colors.white,
      borderRadius: theme.border.large,
      marginHorizontal: theme.spacing.lg,
      marginBottom: theme.spacing.xl,
      paddingVertical: theme.spacing.lg,
      paddingHorizontal: theme.spacing.lg,
      shadowColor: theme.colors.black,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.1,
      shadowRadius: 4,
      elevation: 3,
    },
    checkboxContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    checkbox: {
      width: 20,
      height: 20,
      borderRadius: 4,
      borderWidth: 2,
      borderColor: theme.colors.lightGrey,
      marginRight: theme.spacing.md,
      alignItems: 'center',
      justifyContent: 'center',
    },
    checkboxSelected: {
      backgroundColor: theme.colors.primary,
      borderColor: theme.colors.primary,
    },
    // The standard small spinner is as large as the box: shrunk to fit inside.
    checkboxSpinner: {
      position: 'absolute',
      transform: [{ scale: 0.6 }],
    },
    geolocationText: {
      flex: 1,
      color: theme.colors.secondary,
      fontSize: theme.fontSize.small,
    },
  })
